import styled, {css} from 'styled-components';

import {breakpoint, colors} from 'theme';

export const Root = styled.div`
    padding: 10px;
    height: 300px;

    svg {
        max-width: 100%;
    }
`;

export const TooltipContainer = styled.div<{isWide?: boolean}>`
    display: flex;
    flex-flow: column wrap;
    max-width: 250px;
    font-size: 12px;
    background: ${colors.white};
    color: #303030;
    padding: 8px;
    border-radius: 6px;
    background: ${colors.white};
    box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.25);

    ${(p) =>
        p.isWide &&
        css`
            width: 170px;
            @media (min-width: ${breakpoint.tablet}) {
                width: 200px;
            }
        `}
`;
